import * as React from 'react';
import ScaledValue, { ScaledValueProps } from './ScaledValue';

type Props = {
  count: number;
};

export default class ScaledCount extends React.Component<
  Props & ScaledValueProps
> {
  render() {
    const { count, ...rest } = this.props;
    return <ScaledValue value={count} base={1000} {...rest} />;
  }
}
